import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { ReportAnswers } from '../FeedbackReport';
import { formattedDate } from 'shared/utils/date';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import {
  getDatesPeriod,
  getDescription,
  getLocations,
} from 'npo/pages/ReportBuilder/Components/ReportFinalize/answersUtil';

interface ReportDescriptionProps {
  answers: ReportAnswers;
  defaultDescription?: string;
  legacyIr?: {
    startDate?: string;
    endDate?: string;
    location?: string;
  };
}

const StyledDiv = styled.div`
  display: flex;
  margin: 0 ${SPACERS.medium} ${SPACERS.medium};
  background-color: ${COLORS.whiteBase};
  padding: ${SPACERS.medium} ${SPACERS.extraLarge};
  gap: ${SPACERS.large};
  .description-column {
    flex: 1;
  }
  .location-column {
    max-width: 175px;
    .location-details {
      margin-bottom: ${SPACERS.large};
    }
  }
  .entry {
    display: flex;
    gap: ${SPACERS.tiny};
    margin-bottom: ${SPACERS.tiny};
    justify-content: space-between;
  }
`;

const ReportDescription: React.FC<ReportDescriptionProps> = ({
  answers,
  defaultDescription,
  legacyIr,
}) => {
  let description = getDescription(answers.description) || defaultDescription;
  let locations = getLocations(answers.location);
  if (locations.length === 0 && legacyIr?.location) {
    locations = [{ type: 'all', address: legacyIr.location }];
  }
  const dates = getDatesPeriod(answers.dates);

  if (description?.toLowerCase() === 'no available') {
    description = defaultDescription;
  }

  const programStart = formattedDate(dates.startDate) || legacyIr?.startDate;
  const programEnd = formattedDate(dates.endDate) || legacyIr?.endDate;

  return (
    <StyledDiv>
      <div className="description-column">
        <TrueImpactText variant="heading-label">DESCRIPTION</TrueImpactText>
        <TrueImpactText variant="body-small">{description}</TrueImpactText>
      </div>
      <div className="location-column">
        <div className="location-details">
          <TrueImpactText variant="heading-label">LOCATION</TrueImpactText>
          {locations.length === 0 && (
            <TrueImpactText variant="body-small">
              No location available
            </TrueImpactText>
          )}
          {locations.map(l => (
            <div key={l.address} className="entry">
              <TrueImpactText variant="body-small-bold">
                {l.address}
              </TrueImpactText>
              {l.percentage && (
                <TrueImpactText variant="body-small">
                  {l.percentage}%
                </TrueImpactText>
              )}
            </div>
          ))}
        </div>
        <div className="timeline-details">
          <TrueImpactText variant="heading-label">
            PROGRAM TIMELINE
          </TrueImpactText>
          <TrueImpactText variant="body-small" className="entry">
            <strong>Program start:</strong> {programStart}
          </TrueImpactText>
          <TrueImpactText variant="body-small" className="entry">
            <strong>Program end:</strong> {programEnd}
          </TrueImpactText>
        </div>
      </div>
    </StyledDiv>
  );
};

export default ReportDescription;
